import Modal from 'components/global/Modal'
import { Col, Row } from 'components/grid'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useState } from 'react'

import MaterialButton from './MaterialButton'

interface Props {
	language: 'english' | 'spanish'
}

const HomeCoachMagnets = ({ language }: Props) => {
	const [show, setShow] = useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const data = useStaticQuery(graphql`
		query {
			contentfulModal(name: { eq: "Home Coach Magnets" }) {
				title
				description {
					description
				}
				image {
					gatsbyImageData(placeholder: BLURRED)
				}
			}
		}
	`)

	const title = data.contentfulModal.title
	const description = data.contentfulModal.description.description
	const image = language === 'english' ? data.contentfulModal.image[0].gatsbyImageData : data.contentfulModal.image[1].gatsbyImageData

	return (
		<React.Fragment>
			<MaterialButton onClick={handleShow} image={image} title={title} />
			<Modal title={title} isOpen={show} handleClose={handleClose} wide>
				<Row>
					<Col>
						<p className="text-lg text-slate-400">{description}</p>
					</Col>
					<Col>
						<div className="flex justify-center">
							<GatsbyImage image={image} alt={title} className="max-h-[500px]" />
						</div>
					</Col>
				</Row>
			</Modal>
		</React.Fragment>
	)
}

export default HomeCoachMagnets
